import React from 'react';

import {assert} from 'Asserts';
import {SAMPLE_RESTRICTION_STATUS_LABELS, SampleRestrictionStatus} from 'constants/SampleStatusConstants';
import {MultiValueFilter} from 'search/SearchConstants';
import {FilterKey} from 'search/SearchConstants';
import {OptionData} from 'ui-library/menus/MenuConstants';

import DropdownFilterForm, {prefixedToggleText} from './base/DropdownFilterForm';
import {BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

export interface Props extends BaseFilterFormProps {
  filter: MultiValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: MultiValueFilter) => void;
  onRemove?: () => void;
}

export default function SampleRestrictionStatusFilterForm(props: Props): JSX.Element {
  assert(
    props.filter.key === FilterKey.SAMPLE_RESTRICTION_STATUS,
    'Filter form is for sample restriction status only'
  );
  const optionDatas: Array<OptionData> = Object.values(SampleRestrictionStatus).map((value) => ({
    name: SAMPLE_RESTRICTION_STATUS_LABELS[value],
    value,
  }));
  return (
    <DropdownFilterForm
      {...props}
      dropdownToggleText={prefixedToggleText('Status', optionDatas, props.filter)}
      filterStyle={props.filterStyle}
      isMulti={true}
      onChangeValue={(value: Array<string>) => {
        props.onChangeFilter({...props.filter, value});
      }}
      onRemove={props.onRemove}
      optionDatas={optionDatas}
      value={props.filter.value}
    />
  );
}
